export function Logo({ className }: { className?: string }) {
  return (
    <span className={className}>
      <span className="flex items-center gap-2">
        <svg viewBox="0 0 32 32" className="size-8 shrink-0" aria-hidden="true">
          <rect width="32" height="32" rx="8" className="fill-brand-700" />
          <path
            d="M7 19h18M9.5 19a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm9 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M8 19l1.6-5.2A2 2 0 0 1 11.5 12h9a2 2 0 0 1 1.9 1.4L24 19"
            stroke="white"
            strokeWidth="2"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
        <span className="text-lg font-semibold tracking-tight text-slate-900">
          We<span className="text-brand-700">Drive</span>
        </span>
      </span>
    </span>
  );
}
